const { PUBLIC_URL = '/home/public/' } = process.env

export default {
  hotel: {
    couponValue: '10% off',
    promoCouponValue: '$20 off',
    couponDestination: 'Coupon',
    desktop: {
      image: `${PUBLIC_URL}assets/images/promos/hotel-image-2x.png`,
      imageWebP: `${PUBLIC_URL}assets/images/promos/hotel-image-2x.webp`,
      promoImage: `${PUBLIC_URL}assets/images/promos/pool-image.jpg`,
      promoImageWebP: `${PUBLIC_URL}assets/images/promos/pool-image.webp`
    },
    tablet: {
      image: `${PUBLIC_URL}assets/images/promos/hotel-image-tablet-2x.jpg`,
      imageWebP: `${PUBLIC_URL}assets/images/promos/hotel-image-tablet-2x.webp`,
      promoImage: `${PUBLIC_URL}assets/images/promos/pool-image-tablet.jpg`,
      promoImageWebP: `${PUBLIC_URL}assets/images/promos/pool-image-tablet.webp`
    },
    text: 'Book anything today and get 10% off your next Express Deal® Hotel',
    promoText: 'Use code WEEKEND20 for $20 off thousands of hotels. Must spend at least $100 and stay at least two nights.',
    smallPrint: 'Coupon emailed after trip.',
    promoSmallPrint: '',
    link: 'http://www.priceline.com/seizeyoursummersale'
  },
  kaley: {
    image: `${PUBLIC_URL}assets/images/promos/kaley-express-small.png`,
    imageWebP: `${PUBLIC_URL}assets/images/promos/kaley-express-small.webp`
  },
  collections: {
    image: `${PUBLIC_URL}assets/images/promos/hotel-collections-promo-2x.jpg`,
    imageWebP: `${PUBLIC_URL}assets/images/promos/hotel-collections-promo-2x.webp`,
    promoIcon1: {
      content: 'See 3 popular hotels at a heavily discounted price.'
    },
    promoIcon2: {
      content: 'Click choose and we’ll pick one of the 3 hotels.'
    },
    promoIcon3: {
      content: 'See which hotel right after you book!'
    }
  },
  collectionsIcon1: {
    image: `${PUBLIC_URL}assets/images/promos/collections-icon-1.png`,
    alt: '3 hotels',
    content: "You'll see 3 hotels under one discounted price"
  },
  collectionsIcon2: {
    image: `${PUBLIC_URL}assets/images/promos/collections-icon-2.png`,
    alt: 'choose hotel',
    content: "We'll choose one of the 3 hotels shown"
  },
  collectionsIcon3: {
    image: `${PUBLIC_URL}assets/images/promos/collections-icon-3.png`,
    alt: 'confirm hotel',
    content: "You'll see which one we chose after you book"
  },
  vip: {
    image: `${PUBLIC_URL}assets/images/promos/hotel-vip-promo-2x.jpg`,
    imageWebP: `${PUBLIC_URL}assets/images/promos/hotel-vip-promo-2x.webp`
  }
}
